import React from "react";
import {
  Ship,
  CalendarCheck,
  Mail,
  MessageSquare
} from "lucide-react";

const AdminDashboard = () => {
  return (
    <div className="cms-dashboard">

      <div className="cms-page-heading">
        <div>
          <h2>Dashboard</h2>
          <p>
            Welcome to the IndiaBoats content management system.
          </p>
        </div>
      </div>


      <div className="cms-stat-grid">

        <div className="cms-stat-card">
          <div className="cms-stat-icon">
            <Ship size={22} />
          </div>

          <div>
            <span>Yacht Listings</span>
            <strong>0</strong>
          </div>
        </div>


        <div className="cms-stat-card">
          <div className="cms-stat-icon">
            <CalendarCheck size={22} />
          </div>

          <div>
            <span>Bookings</span>
            <strong>0</strong>
          </div>
        </div>


        <div className="cms-stat-card">
          <div className="cms-stat-icon">
            <Mail size={22} />
          </div>

          <div>
            <span>Enquiries</span>
            <strong>0</strong>
          </div>
        </div>


        <div className="cms-stat-card">
          <div className="cms-stat-icon">
            <MessageSquare size={22} />
          </div>

          <div>
            <span>Testimonials</span>
            <strong>0</strong>
          </div>
        </div>

      </div>


      <div className="cms-welcome-card">

        <h3>Website Content</h3>

        <p>
          Use the sidebar to manage the content
          displayed on the IndiaBoats website.
        </p>

      </div>

    </div>
  );
};

export default AdminDashboard;